/**
 * screens/SettlementAlerts/emptyState.ts
 * Copy for the settlement panel — empty, and gated on the offboarding feed.
 */
import type { FlowNode, Step } from '../../components/EmptyState';

export const SETTLE_FLOW: readonly FlowNode[] = [
  { key: 'leave', label: 'Leaving', sub: 'People says so' },
  { key: 'hold', label: 'Holding', sub: 'an open balance', here: true },
  { key: 'settle', label: 'Settle', sub: 'return or deduct' },
  { key: 'close', label: 'Close', sub: 'the assignment ends' },
];

export const SETTLE_STEPS: readonly Step[] = [
  {
    n: '1',
    label: 'People reports a last day',
    hint: 'One alert per open assignment the person still holds.',
  },
  {
    n: '2',
    label: 'Settle before they leave',
    hint: 'The balance is returned, or deducted through Payroll.',
  },
  {
    n: '3',
    label: 'The assignment closes',
    hint: 'Nothing can be posted to it afterwards.',
  },
];

export const SETTLE_COPY = {
  eyebrow: 'Settlement alerts',
  title: 'Nobody is leaving with money in hand',
  blurb:
    'When someone with an open assignment is due to leave, they appear here with their last day and what they are still holding.',
  flowNote:
    'A person holding three assignments is three things to settle, not one — each has its own balance and its own consequence.',
  gateNote: 'Without the offboarding feed this console cannot know who is leaving.',
  footNote: 'Alerts appear here as soon as a last day is reported.',
} as const;
